import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Chip from '../Common/Chip';

import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import DocumentIcon from 'material-ui/svg-icons/action/description';
import CameraIcon from 'material-ui/svg-icons/image/camera';
import AudioIcon from 'material-ui/svg-icons/av/library-music';

class AssetChip extends Component {

    render() {

        let chipProps = {
            label: this.props.data.name,
            theme: this.props.withTheme && 'secondary'
        };

        if (!!this.props.data.asAttachment) {
            if (this.props.data.type !== 'e-learning') {
                chipProps.url = `/cent/asset/${this.props.data.id}/download`;
                chipProps.target = '_blank';
            }
        } else {
            chipProps.url = `/dashboard/asset/${this.props.data.id}`;
        }

        switch(this.props.data.type) {

            case 'text':
                chipProps.avatar = (<SubjectIcon />);
                break;

            case 'document':
                chipProps.avatar = (<DocumentIcon />);
                break;

            case 'image':
                chipProps.avatar = (<CameraIcon />);
                break;

            case 'video':
                chipProps.avatar = (<VideoIcon />);
                break;

            case 'audio':
                chipProps.avatar = (<AudioIcon />);
                break;

            case 'e-learning':
                chipProps.avatar = (<LaunchIcon />);
                break;

            default:
                break;
        }

        if (!!this.props.onDelete) {
            chipProps.onDelete = this.props.onDelete;
        }

        return <Chip {...chipProps} />;
    }
}

AssetChip.propTypes = {
    data:       PropTypes.object.isRequired,
    onDelete:   PropTypes.func,
    withTheme:  PropTypes.bool
};

AssetChip.defaultProps = {
    withTheme:  true
};

export default AssetChip;
